document.addEventListener('DOMContentLoaded', () => {
    // console.log('DOM已加载，开始初始化产品区块高度...');
    const $productBlock = $(".product_block");
    const blockHeight = $productBlock.outerHeight();
    $productBlock.css("height", blockHeight);
    // console.log('产品区块高度设置为:', blockHeight);

    // 类型为 button 的变体选择
    $('.product-card-wrapper variant-selects .pro-option').click(function () {
        handleButtonVariant.call(this);
    });

    // 类型为 select 的变体选择
    $('.product-card-wrapper variant-selects .select__select').change(function () {
        handleSelectVariant.call(this);
    });

    // 按钮型变体处理函数
    function handleButtonVariant() {
        // console.log('--- 按钮型变体选择触发 ---');
        const $option = $(this);
        const $wrapper = $option.closest('.product-card-wrapper');
        const $container = $option.closest('.product__info-container');

        if ($option.hasClass('not-buy')) {
            // console.log('当前选项不可购买，隐藏购买按钮');
            $wrapper.find('.product-form__submit').hide();
            $wrapper.find('.klaviyo-product-container').addClass('btn-show');
            return;
        }

        // console.log('当前选项可购买，显示购买按钮');
        $wrapper.find('.product-form__submit').show();
        $wrapper.find('.klaviyo-product-container').removeClass('btn-show');

        // 更新选中状态
        $option.siblings('.pro-option').removeClass('selected');
        $option.addClass('selected');

        // 获取当前选中选项
        const optionsList = [];
        $container.find('.pro-option.selected').each(function () {
            optionsList.push($(this).text().trim());
        });
        // console.log('当前选中的选项列表:', optionsList);

        // 查找匹配变体并更新
        const variant = findMatchingVariant($container, optionsList);
        if (!variant) return;

        // 更新UI
        $container.find('.product-variant-id').val(variant.id);
        $wrapper.find('.card__media img').attr('srcset', variant.url);
        updatePriceIfNeeded($wrapper, variant.price, variant.comparePrice);
        updateDiscountAmount($wrapper, variant.discountAmount);
    }

    // 下拉型变体处理函数
    function handleSelectVariant() {
        // console.log('--- 下拉型变体选择触发 ---');
        const $select = $(this);
        const $wrapper = $select.closest('.product-card-wrapper');
        const $container = $select.closest('.product__info-container');

        // 获取所有下拉框选中值
        const optionsList = [];
        $container.find('.select__select').each(function () {
            optionsList.push($(this).val().trim());
        });
        // console.log('当前选中的选项列表:', optionsList);

        // 查找匹配变体
        const variant = findMatchingVariant($container, optionsList);
        if (!variant) return;

        // 更新库存状态显示
        const isAvailable = variant.state === 'true';
        $wrapper.find('.product-form__submit').toggle(isAvailable);
        $wrapper.find('.klaviyo-product-container').toggleClass('btn-show', !isAvailable);
        // console.log(`变体库存状态: ${isAvailable ? '有库存' : '无库存'}`);

        // 更新UI
        $container.find('.product-variant-id').val(variant.id);
        $wrapper.find('.card__media img').attr('srcset', variant.url);
        updatePriceIfNeeded($wrapper, variant.price, variant.comparePrice);
        updateDiscountAmount($wrapper, variant.discountAmount);
    }

    // 查找匹配变体 (公共逻辑)
    function findMatchingVariant($container, optionsList) {
        let matchedVariant = null;
        $container.find('.product-variant-option').each(function () {
            const $variant = $(this);
            const variantText = $variant.text().trim();

            const isMatch = optionsList.every(option =>
                variantText.includes(option)
            );

            if (isMatch) {
                matchedVariant = {
                    id: $variant.attr('id'),
                    url: $variant.attr('url'),
                    state: $variant.attr('state'),
                    price: $variant.attr('data-price'),
                    comparePrice: $variant.attr('data-compare-at-price'),
                    discountAmount: $variant.attr('data-discount-amount')
                };
                // console.log('匹配到变体:', matchedVariant);
                return false; // 退出循环
            }
        });
        return matchedVariant;
    }

    // 按需更新价格显示
    function updatePriceIfNeeded($wrapper, price, comparePrice) {
        const $priceContainer = $wrapper.find('.product-price_updated');
        if (!$priceContainer.length) return;

        // console.log('更新价格显示', { price, comparePrice });
        $priceContainer
            .removeClass('hide')
            .find('.product-price_updated__now').text(price);

        $priceContainer
            .find('.product-price_updated__compare').text(comparePrice);

        $wrapper.find('.product-price-range').addClass('hide');
    }

    function updateDiscountAmount($wrapper, discountAmount) {
        const $discountContainer = $wrapper.find('.video-product-section__item-discount-container');
        if (!$discountContainer.length) return;
        const currentDiscountAmount = $discountContainer.find('.video-product-section__item-discount__amount').text().trim();
        // console.log("现在的折扣力度", currentDiscountAmount);

        // 检查 discountAmount 是否有效
        if (!discountAmount || typeof discountAmount !== 'string') {
            // console.log('折扣金额为空或非字符串，跳过更新');
            return;
        }

        // 去除货币符号和千位分隔符（兼容 $,€,£ 等符号和逗号分隔）
        const numericValue = parseFloat(
            discountAmount.replace(/[^\d.-]/g, '')  // 移除非数字字符（保留负号和小数点）
        );

        // console.log('原始折扣金额:', discountAmount, '处理后数值:', numericValue);

        // 检查是否为有效正数
        if (isNaN(numericValue) || numericValue <= 0) {
            // console.log('折扣金额无效（非数字/零/负数），隐藏折扣显示');
            $discountContainer.addClass('hide');
            return;
        }

        // 若数值与之前相同，则不更新
        if (currentDiscountAmount === discountAmount && !$discountContainer.hasClass('hide')) {
            // console.log('折扣金额未变化，跳过更新');
            return;
        }

        // 更新显示
        // console.log('显示有效折扣:', discountAmount);
        $discountContainer
            .removeClass('hide')
            .find('.video-product-section__item-discount__amount')
            .text(discountAmount);
    }
});